import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ value, onChange, onClear }) => {
  return (
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
        <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
      </div>
      <Input
        type="search"
        placeholder="Cari part berdasarkan nama, kode, atau kategori..."
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        className="pl-12 pr-12"
      />
      {value && (
        <button
          onClick={onClear}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full hover:bg-muted flex items-center justify-center transition-colors"
          aria-label="Clear search"
        >
          <Icon name="X" size={16} color="var(--color-muted-foreground)" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;